import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const ShieldIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 14 16" },
        React.createElement("path", { d: "M13.7339 1.70105C11.1656 0.30203 8.67252 0 7 0C5.32748 0 2.83441 0.30203 0.26605 1.70105C0.10363 1.78952 0 1.9654 0 2.15035V9.70388C0 10.2844 0.27234 10.8339 0.74121 11.1993L6.69569 15.7666C6.8752 15.9043 7.1248 15.9043 7.30431 15.7666L13.2588 11.1993C13.7277 10.8339 14 10.2844 14 9.70388V2.15035C14 1.9654 13.8964 1.78952 13.7339 1.70105Z" })));
};

export { ShieldIcon };
//# sourceMappingURL=ShieldIcon.esm.js.map
